import React from 'react'
import moment from 'moment'
import ScanCampaignRow from './ScanCampaignRow'
import 'react-popper-tooltip/dist/styles.css'
import './style.scss'

const tableHeaders = [
  'Campaign ID',
  'Name',
  'Status',
  'Start Date',
  'End Date',
  'Actions',
]

const ScanCampaignTableProperties = () => {
  return {
    headers: tableHeaders,
    row: ({ id, name, status, validFrom, validTill }) => {
      const currentDate = moment()

      // set campaign status
      let campaignStatus = status
      if (currentDate.isAfter(validTill ?? Infinity)) {
        campaignStatus = 'DISABLED'
      } else if (currentDate.isBefore(validFrom) && status === 'ENABLED') {
        campaignStatus = 'SCHEDULED'
      }

      return (
        <ScanCampaignRow
          id={id}
          name={name}
          campaignStatus={campaignStatus}
          validFrom={validFrom}
          validTill={validTill}
        />
      )
    },
  }
}

export default ScanCampaignTableProperties
